// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DraftLabel_wrapper__dmazZ"};